import { render } from "./parte3.vue?vue&type=template&id=6305e46a&scoped=true"
import script from "./parte3.vue?vue&type=script&lang=js"
export * from "./parte3.vue?vue&type=script&lang=js"

import "./parte3.vue?vue&type=style&index=0&id=6305e46a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6305e46a"]])

export default __exports__